import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-instapay-account',
  imports: [RouterOutlet],
  templateUrl: './instapay-account.html',
  styleUrl: './instapay-account.scss',
})
export class InstapayAccount {}